import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard'
import Login from '@/components/Login'
import OrderListOld from '@/components/OrderListOld'
import OrderList from '@/components/Orders/OrderList'
import Order from '@/components/Order'
import Mapview from '@/components/MapView'
import UserList from '@/components/Users/UserList'
import UserDetails from '@/components/Users/UserDetails'
import UserCreate from '@/components/Users/UserCreate'
import ObjectManagement from '@/components/ObjectManagement/ObjectManagement'
import ObjectDataManagement from '@/components/ObjectData/ObjectDataManagement'
import ObjectDataListRoute from '@/components/ObjectData/ObjectDataListRoute'
import ObjectDataEdit from '@/components/ObjectData/ObjectDataEdit'
import ObjectDataAdmin from '@/components/ObjectData/ObjectDataAdmin'
import ObjectDataCreate from '@/components/ObjectData/ObjectDataCreate'
import CustomerList from '@/components/Customers/CustomerList'
import CustomerCreate from '@/components/Customers/CustomerCreate'
import CustomerDetails from '@/components/Customers/CustomerDetails'
import CustomerPlacesList from '@/components/Customers/CustomerPlacesList'
import CustomerPlacesCreate from '@/components/Customers/CustomerPlacesCreate'
import CustomerPlacesDetails from '@/components/Customers/CustomerPlacesDetails'
import FeralcoOrdersList from '@/components/Orders/FeralcoOrdersList'
import FeralcoInternOrderCreate from '@/components/Orders/FeralcoInternOrderCreate'
import FeralcoInternOrderDetails from '@/components/Orders/FeralcoInternOrderDetails'
import FeralcoOrdersDetails from '@/components/Orders/FeralcoOrdersDetails'
import OrderListByType from '@/components/Orders/OrderListByType'
import OrderDetails from '@/components/Orders/OrderDetails'
import OrderCreate from '@/components/Orders/OrderCreate'
import ContainerOrderDetails from '@/components/Orders/ContainerOrderDetails'
import ContainerStates from '@/components/Orders/ContainerStates'
import ContainerOrdersList from '@/components/Orders/ContainerOrdersList'
import ContainerOrderCreate from '@/components/Orders/ContainerOrderCreate'
import InvoiceFeralcoList from '@/components/Invoices/InvoiceFeralcoList'
import InvoiceFeralcoInternList from '@/components/Invoices/InvoiceFeralcoInternList'
import InvoiceHydroList from '@/components/Invoices/InvoiceHydroList'
import InvoiceFeralcoCreate from '@/components/Invoices/InvoiceFeralcoCreate'
import InvoiceFeralcoInternCreate from '@/components/Invoices/InvoiceFeralcoInternCreate'
import InvoiceHydroCreate from '@/components/Invoices/InvoiceHydroCreate'
import InvoiceSubArchive from '@/components/Invoices/InvoiceSubArchive'
import InvoiceArchive from '@/components/Invoices/InvoiceArchive'
import FeralcoPricesListAdmin from '@/components/FeralcoPrices/FeralcoPricesListAdmin'
import Planning from '@/components/Planning/Planning'
import PlanningArchive from '@/components/Planning/PlanningArchive'
import PlanningExternal from '@/components/Planning/PlanningExternal'
import OrderArchive from '@/components/Orders/OrderArchive'
import OrderAdmin from '@/components/Orders/OrderAdmin'
import InvoiceSettings from '@/components/Invoices/InvoiceSettings'
import FeralcoStats from '@/components/Statistics/FeralcoStats.vue'
import InvoiceSubContractorEdit from '@/components/Admin/InvoiceSubContractorEdit'
import InvoiceEdit from '@/components/Admin/InvoiceEdit'
import FeralcoStatsTonnage from '@/components/Statistics/FeralcoStatsTonnage'
import WaitStats from '@/components/Statistics/WaitStats'
import DocumentList from '@/components/Files/DocumentList'
import DistanceStats from '@/components/Statistics/DistanceStats'
import DeliveryStats from '@/components/Statistics/DeliveryStats'
import DailyCheckup from '@/components/Statistics/DailyCheckup'

import store from '../store.js'

Vue.use(Router)

const routePropId2Nbr = (route) => {
  return {
    id: parseInt(route.params.id),
    archive: route.params.archive
  }
}

const router = new Router({
  routes: [
    {
      path: '/feralcostats',
      name: 'FeralcoStats',
      component: FeralcoStats
    },
    {
      path: '/feralcostatstonnage',
      name: 'FeralcoStatsTonnage',
      component: FeralcoStatsTonnage
    },
    {
      path: '/waitstats',
      name: 'WaitStats',
      component: WaitStats
    },
    {
      path: '/deliverystats',
      name: 'Deliverystats',
      component: DeliveryStats
    },
    {
      path: '/documentlist',
      name: 'DocumentList',
      component: DocumentList
    },
    {
      path: '/orderArchive',
      name: 'OrderArchive',
      component: OrderArchive
    },
    {
      path: '/planning',
      name: 'Planning',
      component: Planning
    },
    {
      path: '/planningarchive',
      name: 'PlanningArchive',
      component: PlanningArchive
    },
    {
      path: '/planningexternal',
      name: 'PlanningExternal',
      component: PlanningExternal
    },
    {
      path: '/objectDataManagement',
      name: 'ObjectDataManagement',
      component: ObjectDataManagement
    },
    {
      path: '/objectDataAdmin',
      name: 'ObjectDataAdmin',
      component: ObjectDataAdmin
    },
    {
      path: '/objectManagement',
      name: 'ObjectManagement',
      component: ObjectManagement
    },
    {
      path: '/objectDataList/:id',
      name: 'ObjectDataList',
      component: ObjectDataListRoute
    },
    {
      path: '/objectDataEdit/:id',
      name: 'ObjectDataEdit',
      component: ObjectDataEdit
    },
    {
      path: '/objectDataCreate',
      name: 'ObjectDataCreate',
      component: ObjectDataCreate
    },
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/Dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/mapview',
      name: 'mapview',
      component: Mapview
    },
    {
      path: '/orderListOld',
      name: 'OrderListOld',
      component: OrderListOld
    },
    {
      path: '/orderList',
      name: 'OrderList',
      component: OrderList
    },
    {
      path: '/ordercreate/:id',
      name: 'OrderCreate',
      component: OrderCreate
    },
    {
      path: '/order/:id',
      name: 'Order',
      component: Order
    },
    {
      path: '/userlist',
      name: 'Användare',
      component: UserList
    },
    {
      path: '/userdetails/:id',
      name: 'UserDetails',
      component: UserDetails
    },
    {
      path: '/usercreate',
      name: 'UserCreate',
      component: UserCreate
    },
    {
      path: '/customerList',
      name: 'CustomerList',
      component: CustomerList
    },
    {
      path: '/customerCreate',
      name: 'CustomerCreate',
      component: CustomerCreate
    },
    {
      path: '/customerDetails/:id',
      name: 'CustomerDetails',
      component: CustomerDetails
    },
    {
      path: '/customerPlacesList',
      name: 'CustomerPlacesList',
      component: CustomerPlacesList,
      props: true
    },
    {
      path: '/customerPlacesCreate',
      name: 'CustomerPlacesCreate',
      component: CustomerPlacesCreate
    },
    {
      path: '/customerPlacesDetails/:id',
      name: 'CustomerPlacesDetails',
      component: CustomerPlacesDetails,
      props: true
    },
    {
      path: '/feralcoOrdersList/:id',
      name: 'FeralcoOrdersList',
      component: FeralcoOrdersList,
      props: true
    },
    {
      path: '/containerOrdersList/:id',
      name: 'ContainerOrdersList',
      component: ContainerOrdersList,
      props: true
    },
    {
      path: '/feralcoInternOrderCreate',
      name: 'FeralcoInternOrderCreate',
      component: FeralcoInternOrderCreate
    },
    {
      path: '/containerOrderCreate',
      name: 'ContainerOrderCreate',
      component: ContainerOrderCreate
    },
    {
      path: '/containerStates',
      name: 'ContainerStates',
      component: ContainerStates
    },
    {
      path: '/distanceStats',
      name: 'DistanceStats',
      component: DistanceStats
    },
    {
      path: '/feralcoOrdersDetails/:id',
      name: 'FeralcoOrdersDetails',
      component: FeralcoOrdersDetails
    },
    {
      path: '/feralcoInternOrderDetails/:id',
      name: 'FeralcoInternOrderDetails',
      component: FeralcoInternOrderDetails
    },
    {
      path: '/containerOrderDetails/:id',
      name: 'ContainerOrderDetails',
      component: ContainerOrderDetails
    },
    {
      path: '/orderlistbytype/:id',
      name: 'OrderListByType',
      component: OrderListByType,
      props: true
    },
    {
      path: '/orderlistbytype/:id/:customer',
      name: 'OrderListByType',
      component: OrderListByType,
      props: true
    },
    {
      path: '/orderdetails/:id',
      name: 'OrderDetails',
      component: OrderDetails
    },
    {
      path: '/orderadmin',
      name: 'OrderAdmin',
      component: OrderAdmin
    },
    {
      path: '/invoiceFeralcoList',
      name: 'InvoiceFeralcoList',
      component: InvoiceFeralcoList
    },
    {
      path: '/invoiceFeralcoInternList',
      name: 'InvoiceFeralcoInternList',
      component: InvoiceFeralcoInternList
    },
    {
      path: '/invoiceHydroList',
      name: 'InvoiceHydroList',
      component: InvoiceHydroList
    },
    {
      path: '/invoiceFeralcoCreate/:id',
      name: 'InvoiceFeralcoCreate',
      component: InvoiceFeralcoCreate,
      props: routePropId2Nbr
    },
    {
      path: '/invoiceFeralcoInternCreate/:id',
      name: 'InvoiceFeralcoInternCreate',
      component: InvoiceFeralcoInternCreate,
      props: routePropId2Nbr
    },
    {
      path: '/invoiceHydroCreate/:id',
      name: 'InvoiceHydroCreate',
      component: InvoiceHydroCreate,
      props: routePropId2Nbr
    },
    {
      path: '/feralcoPricesListAdmin',
      name: 'FeralcoPricesListAdmin',
      component: FeralcoPricesListAdmin
    },
    {
      path: '/invoiceSettings',
      name: 'InvoiceSettings',
      component: InvoiceSettings
    },
    {
      path: '/invoiceSubArchive',
      name: 'InvoiceSubArchive',
      component: InvoiceSubArchive
    },
    {
      path: '/invoiceArchive',
      name: 'InvoiceArchive',
      component: InvoiceArchive
    },
    {
      path: '/admin/invoiceSubContractorEdit',
      name: 'InvoiceSubContractorEdit',
      component: InvoiceSubContractorEdit
    },
    {
      path: '/admin/invoiceEdit',
      name: 'InvoiceEdit',
      component: InvoiceEdit
    },
    {
      path: '/dailyCheckup',
      name: 'DailyCheckup',
      component: DailyCheckup
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/')
  } else {
    if (localStorage.getItem('role') === 'Extern') {
      if (to.name === 'PlanningExternal' || to.name === 'FeralcoStats' || to.name === 'FeralcoOrdersDetails' || to.name === 'FeralcoInternOrderDetails') {
        next()
      } else {
        return
      }
    }
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js